import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Phone, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

const Danke = () => {
  return (
    <div className="bg-white py-16">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center">
        <CheckCircle className="h-20 w-20 text-[#16A34A] mx-auto mb-6" />
        <h1 className="text-4xl font-bold text-[#0F172A] mb-4">Vielen Dank für Ihre Anfrage!</h1>
        <p className="text-lg text-gray-700 mb-8">
          Wir haben Ihre Anfrage erhalten und melden uns schnellstmöglich mit Ihrem 
          Festpreis-Angebot zurück. In der Regel erfolgt unsere Rückmeldung am selben Tag.
        </p>

        <div className="bg-gray-50 rounded-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Wie geht es weiter?</h2>
          <ol className="text-left space-y-4 max-w-xl mx-auto">
            <li className="flex items-start gap-3">
              <span className="w-8 h-8 bg-[#16A34A] text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">1</span>
              <span className="text-gray-700 pt-1">
                Wir prüfen Ihre Angaben und erstellen ein individuelles Angebot
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-8 h-8 bg-[#16A34A] text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">2</span>
              <span className="text-gray-700 pt-1">
                Sie erhalten Ihr verbindliches Festpreis-Angebot per E-Mail oder Telefon
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-8 h-8 bg-[#16A34A] text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">3</span>
              <span className="text-gray-700 pt-1">
                Bei Bedarf vereinbaren wir einen Besichtigungstermin oder klären Details
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="w-8 h-8 bg-[#16A34A] text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold">4</span>
              <span className="text-gray-700 pt-1">
                Nach Ihrer Bestätigung vereinbaren wir den Räumungstermin
              </span>
            </li>
          </ol>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-semibold text-[#0F172A] mb-4">Dringend? Kontaktieren Sie uns direkt:</h3>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-[#16A34A] hover:bg-[#16A34A]/90 text-white">
              <a href="tel:+4923139085116" className="flex items-center gap-2">
                <Phone className="h-5 w-5" />
                0231 39085116
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-[#16A34A] text-[#16A34A] hover:bg-[#16A34A] hover:text-white">
              <a href="mailto:info@haushaltsaufloesung.services" className="flex items-center gap-2">
                <Mail className="h-5 w-5" />
                E-Mail senden
              </a>
            </Button>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <Button asChild variant="outline">
            <Link to="/">Zur Startseite</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Danke;